import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoJourney = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 396,
	height: 214,
	viewBox: "0 0 396 214",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M101.032 164.744C143.558 164.744 178.032 130.27 178.032 87.7441C178.032 45.2182 143.558 10.7441 101.032 10.7441C58.5057 10.7441 24.0316 45.2182 24.0316 87.7441C24.0316 130.27 58.5057 164.744 101.032 164.744Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			style: { opacity: .8 }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M382.432 172.244H16.9316L73.8316 95.8441L98.2316 63.4441L119.532 86.5441L123.632 90.9441L169.432 27.5441L189.032 0.444092L204.332 22.7441L256.432 98.6441L277.432 74.6441L288.132 62.3441L297.232 73.2441L382.432 172.244Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.2316 63.4441L97.2316 172.244H16.9316L73.8316 95.8441L98.2316 63.4441Z",
			fill: "#E0E4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.032 0.444092L185.732 160.844L122.765 92.3837L189.032 0.444092Z",
			fill: "#E0E4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.032 156.544L255.403 100.221L288.132 62.3442L290.032 156.544Z",
			fill: "#E0E4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.53162 173.244H97.2316H382.432H394.132",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.932 187.444H233.332",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M277.932 187.444H303.332",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.432 187.444H267.832",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.7316 187.444H184.732",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.3317 187.444H66.8317",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.632 187.444H379.632",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.83154 187.444H37.9315",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6316 199.944H132.132",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.532 199.944H262.432",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M298.932 199.944H369.832",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.932 199.944H177.432",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240.532 212.344H326.332",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.332 212.344H207.932",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.332 212.344H132.132",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.6316 212.344H89.7316",
			stroke: "#D6DCE8",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.032 147.344C135.032 153.644 129.932 156.444 123.732 156.444C117.532 156.444 112.432 153.644 112.432 147.344C112.432 141.044 123.732 102.144 123.732 102.144C123.732 102.144 135.032 141.144 135.032 147.344Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.632 136.344V172.044",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.632 142.544L127.732 138.844",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.632 151.044L117.732 144.044",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.632 145.544C236.632 152.544 230.932 155.644 224.032 155.644C217.032 155.644 211.432 152.544 211.432 145.544C211.432 138.544 224.032 95.2441 224.032 95.2441C224.032 95.2441 236.632 138.644 236.632 145.544Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.032 133.244V173.044",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.032 140.244L228.532 136.044",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.032 149.744L217.432 141.844",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.632 156.244C264.632 160.544 261.132 162.444 256.932 162.444C252.632 162.444 249.232 160.544 249.232 156.244C249.232 151.944 256.932 125.444 256.932 125.444C256.932 125.444 264.632 151.944 264.632 156.244Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.832 148.744V173.044",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.832 152.944L259.632 150.444",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.832 158.744L252.832 153.944",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M318.932 151.444C318.932 156.944 314.532 159.344 309.032 159.344C303.532 159.344 299.132 156.944 299.132 151.444C299.132 145.944 309.032 111.844 309.032 111.844C309.032 111.844 318.932 145.944 318.932 151.444Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.032 141.744V173.044",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.032 147.144L312.532 143.944",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.032 154.644L303.832 148.444",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M124.532 91.5441L107.332 93.0441L99.3317 101.244L89.7317 99.5441L73.8317 109.444L68.8317 102.944L98.5317 63.4441L124.532 91.5441Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M212.132 34.0441L204.032 32.2441L195.732 36.1441L189.032 34.4441L182.632 45.8441L172.632 41.1441L161.432 45.8441L159.532 41.4441L189.032 0.444092L212.132 34.0441Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M302.532 79.0442L294.132 85.6442L286.332 81.3442L275.332 87.7442L272.232 81.0442L288.532 62.3442L302.532 79.0442Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.6316 33.8442C92.2316 33.4442 93.7316 33.3442 95.3316 33.3442C96.8316 33.3442 98.4316 33.4442 99.9316 33.6442C101.432 33.8442 103.032 34.2442 104.532 34.9442C106.032 35.6442 107.532 36.6442 108.432 38.3442L106.732 37.9442L108.532 36.5442C109.232 36.1442 109.832 35.6442 110.432 35.2442C111.732 34.4442 113.132 33.7442 114.632 33.2442C116.132 32.7442 117.632 32.3442 119.132 32.1442C120.732 32.0442 122.232 32.0442 123.832 32.4442C124.132 32.5442 124.232 32.8442 124.132 33.0442C124.032 33.3442 123.832 33.4442 123.532 33.3442H123.432C122.132 33.0442 120.632 33.1442 119.232 33.3442C117.832 33.5442 116.432 34.0442 115.132 34.6442C113.832 35.2442 112.632 35.9442 111.432 36.7442C110.832 37.1442 110.232 37.6442 109.732 38.0442L108.132 39.4442C107.632 39.8442 107.032 39.7442 106.632 39.3442L106.532 39.4442L106.432 39.2442C106.032 38.1442 104.932 37.2442 103.732 36.6442C102.532 36.0442 101.132 35.5442 99.6316 35.2442C98.2316 34.9442 96.7316 34.7442 95.2316 34.6442C93.7316 34.5442 92.2316 34.5442 90.9316 34.8442H90.8316C90.5316 34.9442 90.3316 34.7442 90.2316 34.4442C90.2316 34.1442 90.3316 33.8442 90.6316 33.8442Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.2315 61.2441C47.8315 60.8441 49.3315 60.7441 50.9315 60.7441C52.4315 60.7441 54.0315 60.8441 55.5315 61.0441C57.0315 61.2441 58.6315 61.6441 60.1315 62.3441C61.6315 63.0441 63.1315 64.0441 64.0315 65.7441L62.3315 65.3441L64.1315 63.9441C64.8315 63.5441 65.4315 63.0441 66.0315 62.6441C67.3315 61.8441 68.7315 61.1441 70.2315 60.6441C71.7315 60.1441 73.2315 59.7441 74.7315 59.5441C76.3315 59.4441 77.8315 59.4441 79.4315 59.8441C79.7315 59.9441 79.8315 60.2441 79.7315 60.4441C79.6315 60.7441 79.4315 60.8441 79.1315 60.7441H79.0315C77.7315 60.4441 76.2315 60.5441 74.8315 60.7441C73.4315 60.9441 72.0315 61.4441 70.7315 62.0441C69.4315 62.6441 68.2315 63.3441 67.0315 64.1441C66.4315 64.5441 65.8315 65.0441 65.3315 65.4441L63.7315 66.8441C63.2315 67.2441 62.6315 67.1441 62.2315 66.7441L62.1315 66.6441L62.0315 66.4441C61.6315 65.3441 60.5315 64.4441 59.3315 63.8441C58.1315 63.2441 56.7315 62.7441 55.2315 62.4441C53.8315 62.1441 52.3315 61.9441 50.8315 61.8441C49.3315 61.7441 47.8315 61.7441 46.5315 62.0441H46.4315C46.1315 62.1441 45.9315 61.9441 45.8315 61.6441C45.8315 61.5441 46.0315 61.2441 46.2315 61.2441Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.432 57.3442C103.032 56.9442 104.532 56.8442 106.132 56.8442C107.632 56.8442 109.232 56.9442 110.732 57.1442C112.232 57.3442 113.832 57.7442 115.332 58.4442C116.832 59.1442 118.332 60.1442 119.232 61.8442L117.532 61.4442L119.332 60.0442C120.032 59.6442 120.632 59.1442 121.232 58.7442C122.532 57.9442 123.932 57.2442 125.432 56.7442C126.932 56.2442 128.432 55.8442 129.932 55.6442C131.532 55.5442 133.032 55.5442 134.632 55.9442C134.932 56.0442 135.032 56.3442 134.932 56.5442C134.832 56.8442 134.632 56.9442 134.332 56.8442H134.232C132.932 56.5442 131.432 56.6442 130.032 56.8442C128.632 57.0442 127.232 57.5442 125.932 58.1442C124.632 58.7442 123.432 59.4442 122.232 60.2442C121.632 60.6442 121.032 61.1442 120.532 61.5442L118.932 62.9442C118.432 63.3442 117.832 63.2442 117.432 62.8442L117.332 62.7442L117.232 62.5442C116.832 61.4442 115.732 60.5442 114.532 59.9442C113.332 59.3442 111.932 58.8442 110.432 58.5442C109.032 58.2442 107.532 58.0442 106.032 57.9442C104.532 57.8442 103.032 57.8442 101.732 58.1442H101.632C101.332 58.2442 101.132 58.0442 101.032 57.7442C101.032 57.6442 101.132 57.3442 101.432 57.3442Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M382.569 173.331H17.0693L73.9693 96.931L98.3693 64.531L119.669 87.631L121.719 89.831L123.769 92.031L169.569 28.631L189.169 1.53101L204.469 23.831L256.569 99.731L277.569 75.731L288.269 63.431L297.369 74.331L382.569 173.331Z",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.375 76.7484C171.375 81.1212 167.839 84.6574 163.428 84.6574C163.352 84.6574 162.706 84.6574 157.953 84.6574C154.645 84.6574 149.359 84.6574 140.918 84.6574H136.888C131.602 84.7715 127.382 80.5508 127.382 75.4556C127.382 70.3224 131.64 66.0638 137.002 66.3299C141.602 51.957 162.668 53.9722 164.455 68.8395C168.409 69.3338 171.375 72.6799 171.375 76.7484Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.341 68.8776C164.036 68.8396 163.732 68.8396 163.428 68.8396C161.869 68.8396 160.386 69.2959 159.131 70.0944",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.341 68.8776C164.036 68.8396 163.732 68.8396 163.428 68.8396C161.869 68.8396 160.386 69.2959 159.131 70.0944",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.002 66.3301C136.545 67.6989 136.317 69.1438 136.317 70.6648C136.317 71.2732 136.355 71.8435 136.431 72.4139",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.002 66.3301C136.545 67.6989 136.317 69.1438 136.317 70.6648C136.317 71.2732 136.355 71.8435 136.431 72.4139",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.432 58.2137C262.432 63.9236 257.814 68.5412 252.054 68.5412C251.955 68.5412 251.111 68.5412 244.905 68.5412C240.585 68.5412 233.683 68.5412 222.661 68.5412H217.398C210.496 68.6902 204.985 63.1788 204.985 56.5255C204.985 49.8226 210.546 44.2616 217.547 44.6092C223.555 25.8409 251.061 28.4725 253.395 47.8862C258.559 48.5317 262.432 52.901 262.432 58.2137Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.246 47.9359C252.849 47.8862 252.452 47.8862 252.054 47.8862C250.019 47.8862 248.082 48.482 246.444 49.5247",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.246 47.9359C252.849 47.8862 252.452 47.8862 252.054 47.8862C250.019 47.8862 248.082 48.482 246.444 49.5247",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.547 44.6091C216.951 46.3966 216.653 48.2833 216.653 50.2694C216.653 51.0638 216.703 51.8086 216.802 52.5534",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.547 44.6091C216.951 46.3966 216.653 48.2833 216.653 50.2694C216.653 51.0638 216.703 51.8086 216.802 52.5534",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgNoJourney as ReactComponent };
